import { render, staticRenderFns } from "./b2c-user-role.vue?vue&type=template&id=e7897b7c&scoped=true&"
import script from "./b2c-user-role.vue?vue&type=script&lang=js&"
export * from "./b2c-user-role.vue?vue&type=script&lang=js&"
import style0 from "./b2c-user-role.vue?vue&type=style&index=0&id=e7897b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7897b7c",
  null
  
)

export default component.exports